import 'core/script/app';
